// extracted by mini-css-extract-plugin
var _1 = "styles_productList__ALp7Q";
var _2 = "styles_shipment__sWA0I";
export { _1 as "productList", _2 as "shipment" }
